import buildInfo from '@valk-nx/build-info.json';
import { MAPBOX_GEOCODING_DEFAULT_URL } from '@valk-nx/services/location-search/src/lib/location-search.service';

/* istanbul ignore next */
export const environment = {
	assetsRoot: 'assets',
	withCredentials: false,
	apiUrl: 'api/v1/',
	mapboxAccessToken: '',
	mapboxGeocodingUrl: MAPBOX_GEOCODING_DEFAULT_URL,
	name: 'valk-nx-content',
	production: false,
	useTransferState: true,
	useRandomHotelOrder: true,
	version: buildInfo?.version || 'test',
};

export const storeVersion = '1';
